import React from 'react';

import WikiBoxInfoBoxLinkRichItem from './WikiBoxInfoBoxLinkRichItem';

type EntityInfoBoxTextItemPropsValue = {
    display: string;
    links: string[];
    type: string;
};

type EntityInfoBoxTextItemProps = {
    label: string;
    value: {
        display: string;
        links: string[];
        type: string;
        values: EntityInfoBoxTextItemPropsValue[];
    };
    openInNewTab: boolean;
    encryptionDetails?: EncryptionDetailsType;
};
export default function WikiBoxInfoBoxTextItem({
    label,
    value,
    openInNewTab,
    encryptionDetails,
}): React.ReactElement<EntityInfoBoxTextItemProps> {
    return (
        <div className="wikiBox__text-wrapper">
            <WikiBoxInfoBoxLinkRichItem
                label={value.display}
                links={value.links}
                openInNewTab={openInNewTab}
                encryptionDetails={encryptionDetails}
            />
        </div>
    );
}
